import { MdOpenInNew } from "react-icons/md";
import { usePlatform } from "components/utils/PlatformContext";

export const NeedHelpButton: React.FC = () => {
  const { supportUrl } = usePlatform();
  try {
    if (!supportUrl) return <></>;
    return (
      <div className="h-fit p-3 rounded-full flex-col justify-center items-center gap-2 inline-flex">
        <div
          className="p-3 bg-neutral-50 hover:bg-neutral-100 ease-in-out duration-150 rounded-full backdrop-blur-[32px] justify-center items-center gap-2 flex cursor-pointer"
          onClick={() =>
            window.open(supportUrl, "_blank", "noopener,noreferrer")
          }
        >
          <div className="w-6 h-6 relative">
            <MdOpenInNew className="w-full h-full fill-secondary-600" />
          </div>
        </div>
        <div className="justify-center items-center gap-0.5 inline-flex">
          <div className="text-center text-secondary-600 text-xs font-semibold font-sans uppercase leading-[14px] tracking-wide select-none">
            Need Help?
          </div>
        </div>
      </div>
    );
  } catch (error) {
    return <></>;
  }
};
